import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MarketTileBtcToGold = ({ data, formatNumber, animate }) => {
  const numberValue = data?.s06?.bitcoin?.market_data?.current_price?.xau != null
    ? `${formatNumber(data.s06.bitcoin.market_data.current_price.xau, 2) ?? "Loading..."} oz.`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Bitcoin~Gold" value={numberValue} />
    </ThemedFlex>
  );
};
